import React from 'react';
import styles from './Banner.module.scss';
import img from './backgroung.png';
import Carousel from 'react-multi-carousel';
import {sliderParams} from "./slider.config";
import {FeaturesItem, InfoSlideItem} from "./components";
import useMedia from "../../../../hooks/useMedia";

export const Banner = (props) => {
    const mobileBreakPoint = useMedia(['(max-width: 800px)'], ['md'], false);

    return (
        !mobileBreakPoint
            ? <div className={styles.container} style={{background: `transparent url(${img}) 10% 100% no-repeat padding-box`}}>
                <Carousel {...sliderParams} className={styles.body} sliderClass={styles.sliderClass} dotListClass={styles.dotListClass}>
                    <div className={styles.slideItem}>
                        <InfoSlideItem/>
                    </div>
                    <div className={styles.slideItem}>
                        <FeaturesItem/>
                    </div>
                </Carousel>
            </div>

            : <div className="flex flex-col pt-4">
                <div className={styles.slideItem}>
                    <InfoSlideItem/>
                </div>
                <div className={styles.slideItem}>
                    <FeaturesItem/>
                </div>
            </div>
    );
};

Banner.propTypes = {}

Banner.defaultProps = {}

export default React.memo(Banner);
